export const HomeverseNetwork = {
  chainId: '0x4A43', // A 0x-prefixed hexadecimal string
  chainName: 'HOME Verse',
  nativeCurrency: {
    name: 'Oasys',
    symbol: 'OAS', // 2-6 characters long
    decimals: 18,
  },
  rpcUrls: ['https://rpc.mainnet.oasys.homeverse.games/'],
  blockExplorerUrls: ['https://explorer.oasys.homeverse.games/'],
}

export const SandverseNetwork = {
  chainId: '0x4EE5', // A 0x-prefixed hexadecimal string
  chainName: 'Sand Verse',
  nativeCurrency: {
    name: 'Oasys',
    symbol: 'OAS', // 2-6 characters long
    decimals: 18,
  },
  rpcUrls: ['https://rpc.sandverse.oasys.games/'],
  blockExplorerUrls: ['https://explorer.oasys.homeverse.games/'],
}

export const OasysMainnet = {
  chainId: '0xf8', // A 0x-prefixed hexadecimal string
  chainName: 'Oasys Mainnet',
  nativeCurrency: {
    name: 'Oasys',
    symbol: 'OAS', // 2-6 characters long
    decimals: 18,
  },
  rpcUrls: ['https://rpc.mainnet.oasys.games/'],
  blockExplorerUrls: ['https://scan.oasys.games/'],
}

export const MaticNetwork = {
  chainId: '0x89', // A 0x-prefixed hexadecimal string
  chainName: 'MATIC',
  nativeCurrency: {
    name: 'Matic',
    symbol: 'MATIC', // 2-6 characters long
    decimals: 18,
  },
  rpcUrls: ['https://rpc-mainnet.maticvigil.com/'],
  blockExplorerUrls: ['https://explorer.matic.network/'],
}

export const EthereumNetwork = {
  chainId: '0x1', // A 0x-prefixed hexadecimal string
  chainName: 'Ethereum',
  nativeCurrency: {
    name: 'Ethereum',
    symbol: 'ETH', // 2-6 characters long
    decimals: 18,
  },
  //https://mainnet.infura.io/v3/undefinedが指定されてたけど一旦置き換え
  rpcUrls: ['https://node.mch.plus/evm/chainid/1'],
  blockExplorerUrls: ['https://etherscan.io'],
}

export const OasysTestnet = {
  chainId: '0x249c', // A 0x-prefixed hexadecimal string
  chainName: 'Oasys Testnet',
  nativeCurrency: {
    name: 'Oasys',
    symbol: 'OAS', // 2-6 characters long
    decimals: 18,
  },
  rpcUrls: ['https://rpc.testnet.oasys.games/'],
  blockExplorerUrls: ['https://explore.testnet.oasys.games/'],
}

export const MumbaiNetwork = {
  chainId: '0x13881', // A 0x-prefixed hexadecimal string
  chainName: 'Mumbai',
  nativeCurrency: {
    name: 'Matic',
    symbol: 'MATIC', // 2-6 characters long
    decimals: 18,
  },
  rpcUrls: ['https://rpc-mumbai.polygon.technology/'],
  blockExplorerUrls: ['https://mumbai.polygonscan.com/'],
}

export const AmoyNetwork = {
  chainId: '0x13882', // A 0x-prefixed hexadecimal string
  chainName: 'Amoy',
  nativeCurrency: {
    name: 'Matic',
    symbol: 'MATIC', // 2-6 characters long
    decimals: 18,
  },
  rpcUrls: ['https://rpc-amoy.polygon.technology/'],
  blockExplorerUrls: ['https://www.oklink.com/amoy'],
}

export const SepoliaNetwork = {
  chainId: '0xaa36a7', // A 0x-prefixed hexadecimal string
  chainName: 'Sepolia',
  nativeCurrency: {
    name: 'Ethereum',
    symbol: 'ETH', // 2-6 characters long
    decimals: 18,
  },
  rpcUrls: ['https://rpc.sepolia.org/'],
  blockExplorerUrls: ['https://sepolia.etherscan.io/'],
}
